import { Injectable } from "@angular/core";
import { SpinnerService } from "app/shared/spinner/spinner.service";
import { ConfigService } from "app/shared/config.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { ResultOfOperation } from "app/shared/model/result-of-operation.model";
import { INofesh } from "app/nofesh/model/nofesh";
import { UserMessagesService } from "app/shared/user-messages/user-messages.service";


@Injectable({
    providedIn: 'root',
  })
export class FavoritesNofashimService {
    private apiUrl: string = "";
    constructor(
        private _spinnerService: SpinnerService,
        private _configService: ConfigService,
        private _httpClientService: HttpClient,
        private _userMessages : UserMessagesService
    ) {
        this.apiUrl = this._configService.getConfigPropertyByKey("apiUrl");
     }

     updateFavoritesNofashim(nofashim : INofesh[]) : Observable<ResultOfOperation<object>>{
        let url : string  = `${this.apiUrl}/api/nofesh/updateFavoritesNofashim`;
        const headers = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClientService.post<ResultOfOperation<object>>(url,nofashim,{headers:headers});
    }

}